import React, { useEffect, useState } from "react";
import logo from "@src/assets/images/smartStudyLogo.svg";
import "../../../assets/css/pagination.css";

const SpinnerForNoteComponent = ({ spiner }) => {
    const [loadingData, setLoadingData] = useState(false);
    useEffect(() => {
        const contentElement = document.getElementsByClassName("content")[0];
        if (contentElement) {
            contentElement.style.marginLeft = "0px";
            setLoadingData(true);
        }
        return () => {
            if (contentElement) {
                contentElement.style.marginLeft = "";
            }
        };
    }, [spiner]);

    return loadingData ? (
        <div
            className={
                spiner
                    ? "spinerTop fallback-spinner app-loader"
                    : "fallback-spinner app-loader"
            }
        >
            <p className="spinnerText mt-3">
                Processing the recording. This may take between 1 to 15 minutes.
                <br />
                Please do not close your window until it is complete.
            </p>
            <img className="fallback-logo" src={logo} alt="logo" />
            <div className="loading">
                <div className="effect-1 effects"></div>
                <div className="effect-2 effects"></div>
                <div className="effect-3 effects"></div>
            </div>
        </div>
    ) : (
        ""
    );
};

export default SpinnerForNoteComponent;
